import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from 'utils/analytics';

const usePageTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, document.title);
  }, [location.pathname]);
};

export default usePageTracking;
